import React, {SFC, useEffect, useRef, useState} from "react";
import {
    Box,
    Grid,
    Paper,
    Typography,
    makeStyles,
    useMediaQuery,
    Button,
    Dialog
} from "@material-ui/core";
import {Theme, useTheme} from "@material-ui/core/styles";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { ReactComponent as DocSVG } from "../../../Images/vetDoctor.svg";
import {
    colorError,
    colorWhite
} from "../../../Constants/theme";
import * as objectorarray from "objectorarray";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {
    updatePickedDate,
    updatePickedTimeSlot,
    updateVetId,
    updateVetProfile,
    updateVetProfileId
} from "../../../redux/scheduleAppointment/scheduling.actions";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import VetProfile from "../../Modals/VetProfile";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import {specialities} from "../../../Constants/specialities";

interface Props {
	name: string,
	profileId: number,
	image: string,
	profile: object,
	userId: number,
	scheduling: objectorarray,
	speciality: objectorarray,
    redirect?: boolean,
}

const SLOT_FORMAT = "h:mm A";

const useStyle = makeStyles((theme: Theme) => ({
    wrapper: {
        height: "100%",
        marginTop: 90,
        marginBottom: 50,
    },
    doctorList: {
        width: "100%",
        padding: 10,
        paddingBottom: 40,
        marginBottom: 40,
        borderBottom: "1px solid #CCCDE5;",
    },
    workDay: {
        marginTop: 10,
        marginRight: 10,
        width: 89,
        height: 26,
        fontSize: 13,
        fontWeight: 400,
        padding: 5,
        flexShrink: 0,
        textAlign: "center",
        borderRadius: "40px",
        color: colorWhite,
        [theme.breakpoints.down("xs")]: {
            width: 95,
        }
    },
    workDays: {
        marginTop: 15,
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap"
    },
    doctorListMobile: {
        padding: "20px 40px"
    },
    avatarPaper: {
        width: 105,
        height: 105,
    },
    availability: {
        marginTop: 10,
        width: "100%",
    }
}));

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & { children?: React.ReactElement<any, any> },
	ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AvaliableVetListItem: SFC<Props> = ({name, profileId, userId, image, speciality, profile, scheduling, redirect = false}: Props) => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const classes = useStyle();
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const brandColor = useSelector((state: RootState) => state?.branding.buttonText);
    const brandAccentColor = useSelector((state: RootState) => state?.branding.brandAccent);
    const imageRef = useRef(null);
    const [linkToImage, setLinkToImage] = useState(image);
    const handleVetProfileClick = (day: string) => {
        dispatch(updateVetProfileId(profileId));
        dispatch(updateVetProfile(profile));
        dispatch(updateVetId(userId));
        dispatch(updatePickedDate(moment(day).toISOString()));
        dispatch(updatePickedTimeSlot([moment(day).format()]));
        redirect ? history.push("/invoice?type=appointment") : history.push("/summary");
    };
    const handleImageLoadError = () => {
        setLinkToImage("");
    };
    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const specs = (speciality || []).map(item => specialities.find(el => el.value === item).label).join(", ");

    const getTimeAmPm = (item, format) => {
        return moment(item).format(format);
    };

    return scheduling.length? (
        <Grid className={`${classes.doctorList} ${isMobile? classes.doctorListMobile : ""}`}>
            <Grid container justify="space-around" alignItems="flex-start">
                <Grid item justify="center">
                    <Box marginBottom={"25px"}>
                        <Paper elevation={3} className={classes.avatarPaper} square>
                            {
                                linkToImage ?
                                    <img
                                        ref={imageRef}
                                        src={linkToImage}
                                        style={{objectFit: "cover"}}
                                        onError={handleImageLoadError}
                                        width="100%"
                                        height="100%"
                                    />
                                    :
                                    <DocSVG className={classes.avatarPaper}/>
                            }
                        </Paper>
                    </Box>
                </Grid>
                <Grid item sm={9} container>
                    <Grid item xs={12} alignItems="center" direction="column">
                        <Box>
                            <a style={{textDecoration: "none", cursor: "pointer"}} onClick={() => setOpen(true)}><Typography variant="h3">{name}  <OpenInNewIcon fontSize="small" /></Typography></a>
                            <Box marginTop="10px">
                                <Typography color="textSecondary" style={{fontSize: 18}}>{specs}</Typography>
                            </Box>
                        </Box>
                        <Box className={classes.availability}>
                            <Grid className={classes.workDays}>
                                {
                                    scheduling.length &&
											scheduling
											    .sort((a,b) => moment(a).diff(moment(b)))
											    .map((timeslot, index) => {
											        return (
											            <Button onClick={() => handleVetProfileClick(timeslot)} className={classes.workDay} key={index}
											                style={{
											                    backgroundColor: isWhiteLabel? brandAccentColor: colorError, color: isWhiteLabel? brandColor : "white"
											                }}>
											                {
											                    getTimeAmPm(timeslot, SLOT_FORMAT)
											                }
											            </Button>);
											    })
                                }
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                scroll="body"
                disableEnforceFocus
            >
                <VetProfile profile={profile} setOpen={setOpen}/>
            </Dialog>
        </Grid>
    ) : null;
};

export default AvaliableVetListItem;
